import { render, staticRenderFns } from "./access-forms-dropdown.vue?vue&type=template&id=48dc8300&scoped=true"
import script from "./access-forms-dropdown.vue?vue&type=script&lang=js"
export * from "./access-forms-dropdown.vue?vue&type=script&lang=js"
import style0 from "./access-forms-dropdown.vue?vue&type=style&index=0&id=48dc8300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dc8300",
  null
  
)

export default component.exports